import {FileService} from '../services/file.service';

 export default function (value) {
  return FileService.getFileType(value);
};
